// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const habalitvColors: ColorType = { ...colorPalette, primary: '#642D93', secondary: '#642D93' }

export const lightTheme = {
  colors: habalitvColors,
  background: {
    primary: '#fafafa',
    secondary: '#fafafa',
    highlight: habalitvColors.light,
    select: '#fafafa',
    footerTop: '#EEDAFF',
    header: '#401466',
  },
  text: {
    primary: habalitvColors.dark,
    secondary: habalitvColors.grayText,
    disabled: habalitvColors.dark,
    link: habalitvColors.dark,
    hint: habalitvColors.dark,
    highlight: habalitvColors.primary,
    gray: habalitvColors.grayText,
    seeAll: 'rgba(52, 73, 94, 0.8)',
    primaryContrast: '#ffffff',
  },
  border: {
    primary: '#dddddd',
    gray: '#ddd',
  },
  filter: {
    primary: '#43484d',
    secondary: '#43484d',
    disabled: habalitvColors.grayLabel,
    highlight: '#fff',
  },
  tabs: {
    bg: '#fafafa',
    containerBg: habalitvColors.dark,
    color: habalitvColors.dark,
    border: habalitvColors.primary,
    scrollbarThumb: habalitvColors.primary,
    programTitle: habalitvColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: 'rgba(221, 221, 221, 0.8)',
        hover: habalitvColors.dark,
        selected: habalitvColors.dark,
        progress: rgba(habalitvColors.primary, 0.3),
        past: rgba(habalitvColors.primary, 0.3),
        pastSelected: habalitvColors.dark,
        pastHover: habalitvColors.dark,
        empty: 'rgba(221, 221, 221, 0.3)',
        emptyProgress: rgba(habalitvColors.primary, 0.1),
      },
      text: {
        empty: habalitvColors.grayLabel,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #fafafa 0%,${rgba('#fafafa', 0.97)} 13.03%,${rgba('#fafafa', 0.69)} 43.24%,${rgba(
          '#fafafa',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0,#fafafa 0%,${rgba('#fafafa', 0.73)} 34.97%,${rgba('#fafafa', 0)} 100%);`,
    },
  },
  card: {
    title: habalitvColors.dark,
    subTitle: habalitvColors.grayText,
    bg: habalitvColors.dark,
    number: habalitvColors.grayBorder,
    boxShadow: 'rgba(221, 221, 221, 0.8)',
    loaderBackgroundImage: 'linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)',
  },
  dimension: {
    signLogoSize: 160,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
